// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2907":"99943b93","4208":"509414c7","7337":"4b9f596d","8309":"5059f8d2","8863":"a2fe7933"}[chunkId] + ".chunk.css";
};